/**
 * Legacy FLUX store
 *
 * NOTE: Don't add new functions to this file as we move to a React Query-based approach for handling server state and data mutations.
 *
 * Aim to refactor the functions in this file to individual hooks following the patterns of `/common/actions`
 */

import AppDispatcher from 'utils/dispatcher/appDispatcher';
import {EventEmitter} from 'events';
import {MESSAGES} from './constants';

const CHANGE_EVENT = 'change';
const UPDATE_EVENT = 'update_event';
const CHANGE_MESSAGES_EVENT = 'change_messages';

let _messages = [];
let _unreadCount = 0;

/**
 * @deprecated
 */
const Store = {
	...EventEmitter.prototype,

	/* Messages */

	getMessages() {
		return _messages;
	},

	getUnreadCount() {
		return _unreadCount;
	},

	setMessageRead(id) {
		_messages = _messages.map(message => {
			const m = {...message};
			if (m.id === id) {
				m.read = 1;
			}
			return m;
		});
		if (_unreadCount > 0) {
			_unreadCount--;
		}
		this.emitMessagesChange();
	},

	setMessageAllRead() {
		_messages = _messages.map(message => {
			const m = {...message};
			m.read = 1;
			return m;
		});
		_unreadCount = 0;
		this.emitMessagesChange();
	},

	/* EVENTS */

	emitChange() {
		this.emit(CHANGE_EVENT);
	},

	addChangeListener(callback) {
		this.on(CHANGE_EVENT, callback);
	},

	removeChangeListener(callback) {
		this.removeListener(CHANGE_EVENT, callback);
	},

	emitUpdate(asset) {
		this.emit(UPDATE_EVENT, asset);
	},

	addUpdateListener(callback) {
		this.on(UPDATE_EVENT, callback);
	},

	removeUpdateListener(callback) {
		this.removeListener(UPDATE_EVENT, callback);
	},

	/* Messages Events */

	emitMessagesChange() {
		this.emit(CHANGE_MESSAGES_EVENT);
	},

	addChangeMessagesListener(callback) {
		this.on(CHANGE_MESSAGES_EVENT, callback);
	},

	removeChangeMessagesListener(callback) {
		this.removeListener(CHANGE_MESSAGES_EVENT, callback);
	},
};

function loadMessages(data) {
	const newMessages = data.messages;

	// Rudimentary check to see if the messages have changed
	// If they have, emit a change event
	if (
		newMessages.length !== _messages.length ||
		newMessages?.[0]?.id !== _messages?.[0]?.id
	) {
		_messages = newMessages;
		_unreadCount = data.unreadCount;
		Store.emitMessagesChange();
	}
}

function appendNewMessage(message) {
	_messages = [message, ..._messages];
	_unreadCount = _unreadCount + 1;
	Store.emitMessagesChange();
}

AppDispatcher.register(payload => {
	const {action} = payload;
	switch (action.actionType) {
		case MESSAGES.LOAD:
			loadMessages(action.data);
			break;

		case MESSAGES.APPEND_MESSAGE:
			appendNewMessage(action.data);
			break;

		default:
			return true;
	}

	return true;
});

export default Store;
